import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import { APP_CONFIG } from '../../app.config';
import { UtilHelper } from '../../shared/helpers/utils.helper';
import { RequestService } from '../../shared/services/request.service';
import { BankAccount } from './models/bank-account.model';
import { Bank } from './models/bank.model';
import { PaymentStatement, PaymentStatementsResponse } from './models/payment-statement.model';

@Injectable()
export class AccountService {

	constructor(private requestService: RequestService) { }

	// BANK DATA
	// -----------------------------------

	getBankAccount(storeId?: number, placeId?: number): Promise<BankAccount> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = APP_CONFIG.WEBSERVICE.BANK_ACCOUNT + (storeId ? "?establishmentId=" + storeId : "?placeId=" + placeId);
			this.requestService.getData(urlRequest).then((response: BankAccount) => {
				resolve(response);
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	getBanks(): Promise<Array<Bank>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = APP_CONFIG.WEBSERVICE.BANK_ACCOUNT + "/banks?status=1";
			this.requestService.getData(urlRequest).then((response: Array<Bank>) => {
				resolve(response);
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	saveBankAccount(bankAccount: BankAccount): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = JSON.parse(JSON.stringify(bankAccount.toJson()));
			console.log(data);
			this.requestService.postData(APP_CONFIG.WEBSERVICE.BANK_ACCOUNT, data).then((response: any) => {
				resolve(response);
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	updateBankAccount(bankAccount: BankAccount): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = JSON.parse(JSON.stringify(bankAccount.toJson()));
			console.log(data);
			this.requestService.putData(APP_CONFIG.WEBSERVICE.BANK_ACCOUNT, data).then((response: any) => {
				resolve(response);
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	// BANK STATEMENTS
	// -----------------------------------

	getPaymentStatements(establishmentId: number, page: number, size: number, count: boolean, translateService: TranslateService): Promise<PaymentStatementsResponse> {
		return new Promise((resolve, reject) => {
			const params: any = {
				establishmentId: establishmentId,
				count: count,
				page: page,
				size: size
			};
			const urlRequest: string = this.requestService.buildUrlPathParams(params, APP_CONFIG.WEBSERVICE.GET_STATEMENTS);
			this.requestService.getData(urlRequest).then((response: PaymentStatementsResponse) => {
				const array: Array<PaymentStatement> = [];
				if (response && response.closingModels) {
					for (const statement of response.closingModels) {
						const paymentStatement: PaymentStatement = this.buildStatementDescription(statement, translateService);
						array.push(paymentStatement);
					}
				}
				response.closingModels = array;
				// Tratamento temporario pra prod
				// if (ENV.mode === 'PROD' && establishmentId !== 4) {
				// 	resolve({
				// 		count: 0,
				// 		closingModels: []
				// 	});
				// } else {
				resolve(response);
				// }
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	getPaymentStatementById(id: number, translateService: TranslateService): Promise<PaymentStatement> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = APP_CONFIG.WEBSERVICE.GET_STATEMENT + id;
			this.requestService.getData(urlRequest).then((response: PaymentStatement) => {
				let paymentStatement: PaymentStatement;
				if (response) {
					paymentStatement = this.buildStatementDescription(response, translateService);
				}
				resolve(paymentStatement);
			}, (erro: Error) => {
				console.log(erro);
				reject(erro);
			});
		});
	}

	private buildStatementDescription(resp: PaymentStatement, translateService: TranslateService): PaymentStatement {
		const paymentStatement: PaymentStatement = new PaymentStatement(resp);
		const balanceFormated: string = UtilHelper.formatAmountAndRemoveNegativeSymbol(paymentStatement.balance);

		// A receber
		if (paymentStatement.balance > 0) {
			paymentStatement.description = translateService.instant(
				"ACCOUNT.BALANCE_TO_RECEIVE", { balance: balanceFormated }
			);
		} else if (paymentStatement.balance < 0) {
			// A pagar com boleto
			if (paymentStatement.firstClosingMonth && paymentStatement.bankSlipDueDate) {
				paymentStatement.description = translateService.instant(
					"ACCOUNT.BALANCE_BANK_SLIP",
					{
						balance: balanceFormated,
						date: moment(paymentStatement.bankSlipDueDate).format("DD/MM/YYYY")
					}
				);
			} else {
				// A pagar com saldo devedor
				paymentStatement.description = translateService.instant(
					"ACCOUNT.BALANCE_DUE", { balance: balanceFormated }
				);
			}
		} else {
			// Saldo R$ 0
			paymentStatement.description = translateService.instant(
				"ACCOUNT.NO_BALANCE", { balance: balanceFormated }
			);
		}
		return paymentStatement;
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/account.service.ts